import {getDelegators} from '_app/shared/features/users/delegators/delegatorsSelectors';

export const getProxiedAs = state => {
	const delegators = getDelegators(state).data;
	const proxiedAsId = state.users.proxiedAs;

	if (!delegators || !proxiedAsId) {
		return null;
	}

	return delegators.find(delegator => delegator.userID === proxiedAsId);
};